import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class YearAndQuaterDataService {
  // Generate years dynamically from 2015 to the current year (or a future year)
  yearData: number[] = this.generateYearData(2015, new Date().getFullYear());

  quarterData = [
    {
      id: 0,
      name: 'All'
    },
    {
      id: 1,
      name: 'Q1 (Jan-Mar)'
    },
    {
      id: 2,
      name: 'Q2 (Apr-Jun)'
    },
    {
      id: 3,
      name: 'Q3 (Jul-Sep)'
    },
    {
      id: 4,
      name: 'Q4 (Oct-Dec)'
    }
  ];

  // Function to generate year data from a start year to an end year
  private generateYearData(startYear: number, endYear: number): number[] {
    const years = [];
    years.push('All');
    for (let year = endYear ; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  }
}
